
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 55 55"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"currentColor","stroke-width":"2.4","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M42.196 52c3.633-2.759 9.78-8.589 9.78-12.947 0-3.534-2.462-5.648-4.843-5.648-2.645 0-3.63 1.909-4.939 4.166-1.308-2.257-2.293-4.166-4.939-4.166-2.38 0-4.843 2.114-4.843 5.648 0 4.358 6.148 10.188 9.782 12.947h.002zM8.528 26.997v25h23.913M2 25.863L27 2l25 23.863M35.703 4.275h7.608v7.954"}}),_c('path',{attrs:{"d":"M23.767 13.374h6.522v6.818h-6.522v-6.818z"}})])])
          )
        }
      }
    